<template>
  <div class="orderNav">
    <el-submenu index="6">
      <template slot="title">
        <i class="iconfont icon-setting-user"></i>
        <span>{{ptitle}}</span>
      </template>
      <el-menu-item
        v-for="(item,i) in menuList"
        :key="i"
        :index="item.index"
        @click="rediret(item)"
      >
        <span slot="title">{{item.title}}</span>
      </el-menu-item>
    </el-submenu>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ptitle: '账户设置',
      menuList: [
        {
          index: '6-1',
          title: '绑定',
          url: '/user/binding'
        },
        {
          index: '6-2',
          title: '提现',
          url: '/user/cash'
        },
        {
          index: '6-3',
          title: '交易明细',
          url: '/user/cashList'
        }
      ]
    }
  },
  created () {
    this.getCurrentIndex(this.$route.path)
  },
  methods: {
    getCurrentIndex (path) {
      if (path.search('user') !== -1) {
        let selectItem = this.menuList.filter(item => item.url === path)
        this.rediret(selectItem[0])
      }
    },
    rediret (item) {
      this.$emit('rediret', item)
    }
  }
}
</script>
<style lang="scss">
.orderNav {
  border-top: 1px solid rgb(33, 42, 50);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/leftnav/userSet.vue